import logo from "assets/images/logo.png";
import { observer } from "mobx-react";
import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { adminRoutes } from "router";
import { settings } from "settings";
import { permissionStore } from "store/permissionStore";
import { userStore } from "store/userStore";
import { getTitle } from "utils";
import authCard from "../../assets/images/auth-card-bg.svg";
import LoginForm from "views/Login/components/Form";
import "./styles/LoginPage.scss";
import { message } from "antd";

type LoginPageProps = {
  title?: string;
};

const LoginPage = observer(({ title = "" }: LoginPageProps) => {
  const [loading, setLoading] = useState(false);
  const navigation = useNavigate();

  useEffect(() => {
    document.title = getTitle(title);
  }, [title]);

  const handleSubmit = async (form: any) => {
    setLoading(true);
    const username = form.username;
    const password = form.password;
    try {
      await userStore.login(username, password);
      await userStore.getProfile();
      permissionStore.accessRoutes = [...adminRoutes];
      if (settings.checkPermission && userStore.info.role) {
        await permissionStore.fetchPermissions(userStore.info.role.id);
        if (!permissionStore.permissions.length) {
          message.error("Không có quyền truy cập");
          throw new Error("");
        }
        permissionStore.setAccessRoutes();
        navigation(permissionStore.permissions[0].path);
      } else {
        navigation("/");
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-page">
      <div className="login-page__container">
        <div className="login-page__content">
          <div className="login-page__decor absolute end-0 top-0">
            <img src={authCard} alt="" aria-hidden="true" />
          </div>

          <div className="login-page__decor absolute start-0 bottom-0 rotate-180">
            <img src={authCard} alt="" aria-hidden="true" />
          </div>

          <div className="login-page__card">
            <div className="login-page__card-body">
              <div className="login-page__brand">
                <img
                  src={logo}
                  width={80}
                  alt="Logo"
                  className="login-page__logo"
                />
                <h4 className="login-page__title">Great to see you here</h4>
                <p className="login-page__subtitle">
                  Let’s get you signed in. Enter your username and password to
                  continue.
                </p>
              </div>

              <LoginForm loading={loading} onSubmit={handleSubmit} />

              <p className="login-page__footer-text">
                New here?&nbsp;
                <Link to="/auth/card/sign-up" className="login-page__link">
                  Create an account
                </Link>
              </p>

              <p className="login-page__footer-text">
                &copy; {new Date().getFullYear()} - {settings.version}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
});

export default LoginPage;
